import { render, staticRenderFns } from "./PositionsView.vue?vue&type=template&id=0a021566&scoped=true"
import script from "./PositionsView.vue?vue&type=script&lang=js"
export * from "./PositionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a021566",
  null
  
)

export default component.exports